const SyncDeclare = {
    test: 'example',
    Users: {},
    Template: {title: '', description: ''},
    TeamVariable: {teamsid: 0, name: '', createdAt: ''},
    ShopVariable: {shopid: 0, name: '', desc: '', createdAt: ''},
    TemplateDom: {},
    ProductConfig: {productcost: 0, fbadspent: 0},
    CustomHeader: [],
    ProductConfigList: (data:any)=>{},
    PayoutMediaBuyer: (data:any,option?:any)=>{},
    SMSTemplate: (shopid:any)=>{},
    OrdersDashboardRefresh: ()=>{},
    TemplateHeader: (title:any, description:any, show?:boolean) =>{
        const TemplateDom:any = SyncDeclare.TemplateDom;
        TemplateDom.querySelector('#header-title').innerHTML = title;
        TemplateDom.querySelector('#header-description').innerHTML = description;
        TemplateDom.querySelector('#header-main').style.display = show || show == null ? 'block' : 'none';
    },
    customFunction: (data: any) => {},
    LoadTeamMembers: ()=>{},
    Permission: (tab: any)=>{
        const user: any = SyncDeclare.Users;
        if(user.permissionid && user.permissionid >= 1){

        }
    },
    SideBar: {
        LoadData: (data: any) => {}
    },
    Modals: {
        ShopDashboard: {
            UserInfo: (details:any)=>{}
        },
        Profile: {
            UserInfo: (details:any)=>{}
        },
        CustomColumn: ()=>{}
    }
}
export default SyncDeclare;